// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  position: relative;
  padding: 8rem 0;
  background: #000;
  overflow: hidden;
}

.section-bg-line {
  position: absolute;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(191,0,255,0.15), transparent);
  pointer-events: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 5rem;
}

.section-tag {
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: #bf00ff;
  display: block;
  margin-bottom: 1rem;
}

.section-title {
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.5rem;
  line-height: 1;
}

.section-title .highlight {
  color: transparent;
  -webkit-text-stroke: 1.5px #bf00ff;
}

.section-desc {
  font-size: 1.05rem;
  color: rgba(255,255,255,0.5);
  max-width: 560px;
  margin: 0 auto;
  line-height: 1.7;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5px;
}

.service-card {
  position: relative;
  padding: 2.5rem 2rem;
  background: #0a0a0a;
  cursor: pointer;
  overflow: hidden;
  transition: background 0.4s;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--accent, #bf00ff), transparent);
  opacity: 0;
  transition: opacity 0.4s;
}

.service-card:hover {
  background: #0f0f0f;
}

.service-card:hover::before {
  opacity: 1;
}

.card-number {
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  color: rgba(255,255,255,0.2);
  margin-bottom: 1.5rem;
  font-family: monospace;
}

.card-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
  display: block;
  transition: transform 0.3s;
}

.service-card:hover .card-icon {
  transform: scale(1.1);
}

.card-title {
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.8rem;
  color: #fff;
}

.card-desc {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.5);
  line-height: 1.7;
  margin-bottom: 1.5rem;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1.5rem;
}

.card-tag {
  font-size: 0.65rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  padding: 0.25rem 0.6rem;
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.35);
  border-radius: 1px;
}

.card-arrow {
  font-size: 1.2rem;
  color: var(--accent, #bf00ff);
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s;
}

.service-card:hover .card-arrow {
  opacity: 1;
  transform: translateX(0);
}

.card-border {
  position: absolute;
  bottom: 0; left: 0;
  width: 0; height: 1px;
  background: var(--accent, #bf00ff);
  transition: width 0.4s ease;
}

.service-card:hover .card-border {
  width: 100%;
}

@media (max-width: 1024px) {
  .services-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 600px) {
  .services-grid { grid-template-columns: 1fr; }
  .services { padding: 5rem 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,sFAAsF;EACtF,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,oFAAoF;EACpF,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO;EAClB,QAAQ,EAAE,WAAW;EACrB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB,qCAAqC,EAAE;AAC1D;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,YAAY,eAAe,EAAE;AAC/B","sourcesContent":[".services {\n  position: relative;\n  padding: 8rem 0;\n  background: #000;\n  overflow: hidden;\n}\n\n.section-bg-line {\n  position: absolute;\n  top: 0; left: 50%;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(to bottom, transparent, rgba(191,0,255,0.15), transparent);\n  pointer-events: none;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 5rem;\n}\n\n.section-tag {\n  font-size: 0.75rem;\n  letter-spacing: 0.3em;\n  text-transform: uppercase;\n  color: #bf00ff;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.section-title {\n  font-size: clamp(2.5rem, 6vw, 4.5rem);\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 1.5rem;\n  line-height: 1;\n}\n\n.section-title .highlight {\n  color: transparent;\n  -webkit-text-stroke: 1.5px #bf00ff;\n}\n\n.section-desc {\n  font-size: 1.05rem;\n  color: rgba(255,255,255,0.5);\n  max-width: 560px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5px;\n}\n\n.service-card {\n  position: relative;\n  padding: 2.5rem 2rem;\n  background: #0a0a0a;\n  cursor: pointer;\n  overflow: hidden;\n  transition: background 0.4s;\n}\n\n.service-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--accent, #bf00ff), transparent);\n  opacity: 0;\n  transition: opacity 0.4s;\n}\n\n.service-card:hover {\n  background: #0f0f0f;\n}\n\n.service-card:hover::before {\n  opacity: 1;\n}\n\n.card-number {\n  font-size: 0.7rem;\n  letter-spacing: 0.2em;\n  color: rgba(255,255,255,0.2);\n  margin-bottom: 1.5rem;\n  font-family: monospace;\n}\n\n.card-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  display: block;\n  transition: transform 0.3s;\n}\n\n.service-card:hover .card-icon {\n  transform: scale(1.1);\n}\n\n.card-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 0.8rem;\n  color: #fff;\n}\n\n.card-desc {\n  font-size: 0.9rem;\n  color: rgba(255,255,255,0.5);\n  line-height: 1.7;\n  margin-bottom: 1.5rem;\n}\n\n.card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1.5rem;\n}\n\n.card-tag {\n  font-size: 0.65rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  padding: 0.25rem 0.6rem;\n  border: 1px solid rgba(255,255,255,0.1);\n  color: rgba(255,255,255,0.35);\n  border-radius: 1px;\n}\n\n.card-arrow {\n  font-size: 1.2rem;\n  color: var(--accent, #bf00ff);\n  opacity: 0;\n  transform: translateX(-10px);\n  transition: all 0.3s;\n}\n\n.service-card:hover .card-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.card-border {\n  position: absolute;\n  bottom: 0; left: 0;\n  width: 0; height: 1px;\n  background: var(--accent, #bf00ff);\n  transition: width 0.4s ease;\n}\n\n.service-card:hover .card-border {\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .services-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 600px) {\n  .services-grid { grid-template-columns: 1fr; }\n  .services { padding: 5rem 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
